<template>
    <div>
        <h2 class="text-left text-2xl my-[3%]">
            <span class="font-medium">{{ $t('offers.title') }}</span>
        </h2>
        <OffersTable
            :offers="offers as SelectedOffer[]"
            :selectOfferMethod="selectOffer"
            :deleteMethod="confirmDeleteSingleOffer"
            :pdfMethod="downloadPdf"
        />
    </div>
</template>

<script lang="ts" setup>
    import OffersTable from './OffersTable.vue'
    import { defineProps } from 'vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { SelectedOffer } from '@/model/types'

    const { selectOffer, confirmDeleteSingleOffer, downloadPdf } = useOfferStore()

    const props = defineProps({
        offers: Array,
        selectOffer: Function,
        confirmDeleteSingleOffer: Function,
        downloadPdf: Function,
        addOfferLink: String,
    })
</script>
